import { AlignLeft, EyeOff, WrapText } from 'lucide-react'
import { useEffect, useRef } from 'react'

interface ColumnContextMenuProps {
  x: number
  y: number
  columnId: string
  columnLabel: string
  isWrapped: boolean
  onHide: () => void
  onToggleWrap: () => void
  onClose: () => void
}

export function ColumnContextMenu({
  x,
  y,
  columnId: _columnId,
  columnLabel,
  isWrapped,
  onHide,
  onToggleWrap,
  onClose,
}: ColumnContextMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        onClose()
      }
    }
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [onClose])

  return (
    <div
      ref={menuRef}
      className="bg-popover border-border fixed z-50 min-w-[160px] rounded-lg border py-1 shadow-xl"
      style={{ left: x, top: y }}
    >
      <button
        type="button"
        onClick={() => {
          onToggleWrap()
          onClose()
        }}
        className="text-foreground hover:bg-muted flex w-full items-center gap-2 px-3 py-2 text-sm transition-colors"
      >
        {isWrapped ? <AlignLeft size={14} /> : <WrapText size={14} />}
        {isWrapped ? 'Truncate text' : 'Wrap text'}
      </button>
      <button
        type="button"
        onClick={() => {
          onHide()
          onClose()
        }}
        className="text-foreground hover:bg-muted flex w-full items-center gap-2 px-3 py-2 text-sm transition-colors"
      >
        <EyeOff size={14} />
        Hide "{columnLabel}"
      </button>
    </div>
  )
}
